import React from "react";
import Header from "src/components/layout/Header";
import Album from "src/components/list/Album";
import Footer from "src/components/layout/Footer";
import PageContent from "src/components/layout/PageContent";
import "src/css/virtual-window.css";
import {useCreation} from "ahooks";
import ProductDetailsPanel from "src/components/details/ProductDetailsPanel";
import {VirtualWindowDataResponse} from "src/model/VirtualWindowDataResponse";


export interface MainPanelProps {
    data: VirtualWindowDataResponse,
    itemUid?: string,
    onItemSelected?: (uid: string) => any,
    onBackButtonPressed?: () => any
}


const MainPanel = ({data, itemUid, onBackButtonPressed, onItemSelected}: MainPanelProps) => {

    const item = useCreation(() => {
        if (data === undefined || itemUid === undefined) {
            return undefined;
        }
        return data.items.find(item => item.uid === itemUid);
    }, [data, itemUid]);


    return (
        <PageContent>
            <Header vw={data.vw} onBackButtonPressed={onBackButtonPressed}/>
            {
                item !== undefined
                    ? (<ProductDetailsPanel data={data} item={item}/>)
                    : (<Album data={data} onItemSelected={onItemSelected}/>)
            }
            <Footer vw={data.vw} item={item}/>
        </PageContent>
    )
}

export default MainPanel;